import { Injectable, Injector } from "@angular/core";
import { BaseResourceService, FavorecidoCbo } from "eddydata-lib";

@Injectable({
    providedIn: 'root'
})
export class FavorecidoCboService extends BaseResourceService<FavorecidoCbo>{

    constructor(
        protected injector: Injector
    ){
        super(`favorecido-cbos`, injector);
    }
}